// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"158":"f548cd36","640":"e992ec4c","858":"f19f4cc1"}[chunkId] + ".chunk.js";
};